import React, { useEffect } from 'react';
import { product_fields } from '../constants/create_product_fields';
import CustomInput from '../../../../components/CustomInput';
import { Button, Typography } from '@mui/material';
import * as MATERIEL_ICONS from '@mui/icons-material/';
import service from '../service';

import { toast } from 'react-toastify';
import { useLocation, useNavigate } from 'react-router-dom';
import { useBoundStore } from '../../../../stores';

function EditProductDrawer() {
  const [productFormData, setProductFormData] = React.useState({
    productName: '',
    productType: '',
    barcodeNumber: '',
    description: '',
    status: 'ACTIVE',
  });

  const { hash } = useLocation();
  const navigate = useNavigate();

  const toggleLeftDrawer = useBoundStore((state) => state.toggleLeftDrawer);

  const getProduct = async () => {
    const response = await service.getProductByBarcodeNumber({
      barcodeNumber: hash.split('#')[1]
    });
    const simData = response?.data;
    setProductFormData(() => ({
      ...simData,
      productName: simData.productName,
      productType: simData.productType,
      barcodeNumber: simData.barcodeNumber,
      description: simData.description,
      status: simData.status,
    }));
  };

  const handleUpdate = async () => {
    // console.log(formData.productFormData);
    await service.updateProduct({
      productId: productFormData?.id,
      data: productFormData,
    }).then((response) => {
      if (response?.status === 200 || response?.status === 201) {
        toast.success('Ürün başarıyla güncellendi.');
      } else {
        toast.error('Ürün güncellenirken bir hata oluştu.');
      }
      navigate('/definitions/products');
      toggleLeftDrawer();
    });
  };

  useEffect(() => {
    getProduct();
  }, [hash]);

  return (
    <div className="mt-5">
      <div className="px-2">
        <Typography variant="h6">Ürün Güncelle</Typography>
      </div>
      <div>
        {/* <EditProgressStepper
          formData={{
            productFormData,
            matchWith: {
              vehicle: vehicle?.id,
              relationId: currentMatch?.id,
            },
          }}
          steps={['Cihaz Bilgileri'
            // , 'Araçla Eşleştir'
          ]}
        > */}
        <>
          <div>
            <div className="flex flex-row flex-wrap justify-center items-center gap-4 w-full my-5">
              {product_fields().map((field, index) => {
                return (
                  <div className=" flex w-full" key={index}>
                    <CustomInput
                      key={index}
                      type={field.type}
                      inputType={field.inputType}
                      defaultValue={field.defaultValue}
                      items={field.items}
                      label={field.placeHolder}
                      value={
                        productFormData !== undefined
                          ? productFormData[field.key]
                          : ''
                      }
                      fullWidth={true}
                      size={'small'}
                      onChange={(key, value) => {
                        setProductFormData({
                          ...productFormData,
                          [field.key]: value,
                        });
                      }}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </>
        {/* <>
            <div className="w-full">
              <div className="flex justify-center items-center">
                Güncel eşleşme: {currentMatch?.vehicle?.id}
              </div>
              <div className="flex flex-row flex-wrap justify-center items-center gap-4 w-full my-5">
                <Autocomplete
                  fullWidth
                  options={vehicles}
                  getOptionLabel={(option) => option?.id}
                  onChange={(e, value) => {
                    setVehicle(value);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Araç Seçin"
                      variant="outlined"
                      size="small"
                      onChange={(e) => handleFilterInput(e.target.value)}
                      value={filterData.query}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {isLoading ? (
                              <CircularProgress color="inherit" size={20} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </div>
            </div>
          </> */}
        {/* </EditProgressStepper> */}
        <div className="flex justify-center items-center my-5">
          <Button
            fullWidth
            disabled={hash === '' || productFormData === undefined}
            variant="contained"
            color="primary"
            onClick={handleUpdate}
            startIcon={<MATERIEL_ICONS.Save />}
          >
            Kaydet
          </Button>
        </div>
        {hash === '' ? (
          <div className="p-2 m-2  flex justify-center items-center">
            <span className="italic">Lütfen bir ürün seçiniz.</span>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default EditProductDrawer;
